import { useState, useCallback, type ReactNode } from 'react';
import { SideContext, type Side, type SideContextValue } from './sideContext';

export interface SideProviderProps {
  children: ReactNode;
}

export function SideProvider({ children }: SideProviderProps) {
  const [activeSide, setActiveSide] = useState<Side>('front');

  const flipSide = useCallback(() => {
    setActiveSide((prev) => (prev === 'front' ? 'back' : 'front'));
  }, []);

  const value: SideContextValue = {
    activeSide,
    flipSide,
    setActiveSide,
  };

  return <SideContext.Provider value={value}>{children}</SideContext.Provider>;
}
